import { combineReducers } from "redux";
import campaignListReducer from "./campaignList/reducers";
import campaignOverviewReducer from "./campaignOverview/reducers";
import campaignAcceptanceReducer from "./acceptance/reducers";
import campaignDetailsReducer from "./details/reducers";
import campaignSoftElectroReducer from "./softElectro/reducers";
import campaignModeReducer from "./campaignMode/reducers";

const campaignReducer = combineReducers({
  list: campaignListReducer,
  overview: campaignOverviewReducer,
  acceptance: campaignAcceptanceReducer,
  details: campaignDetailsReducer,
  softElectro: campaignSoftElectroReducer,
  campaignMode: campaignModeReducer
});

export default campaignReducer;
